import React, { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';
import SubmitModal from 'components/Submits/SubmitModal';
import { Button } from '@mui/material';
import { NavLinkProps } from './helpers/types';
import StyButton from './StyButton';

const ExternalLink = ({
    children,
    url,
    disabled,
    backgroundColor,
}: NavLinkProps) => {
    const { t } = useTranslation();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const onSubmit = useCallback(() => {
        if (disabled) {
            return;
        }
        window.open(url);
    }, [url, disabled]);

    return (
        <>
            <StyButton
                component={Button}
                onClick={() => setShowConfirmationModal(!disabled)}
                backgroundColor={backgroundColor}
                disabled={disabled}
            >
                {children}
            </StyButton>
            <SubmitModal
                submit={onSubmit}
                dialogText={t('widget.navlink.externalLinkText')}
                dialogTitle={t('widget.navlink.externalLinkTitle')}
                open={showConfirmationModal}
                setOpen={setShowConfirmationModal}
            />
        </>
    );
};

export default React.memo(ExternalLink);
